import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from '../../../../shared/services/config.service';
import { UserService } from '../../../../shared/services/user.service';

@Injectable({
  providedIn: 'root'
})
export class PortalTemplateService {

  private get httpOptions() {
    return {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'APIKEY': 'ams-direct-api-admin-key',
        'SessionId': this.userService.sessionId
      })
    };
  }

  constructor(private http: HttpClient, private configService: ConfigService, private userService: UserService) { }

  getEmployeePortalGridColumn(portalTemplateId: number) {
    return this.http.get<any>(`${this.configService.config.adminUrl}/api/portaltemplate/getemployeeportalgridcolumns?portaltemplateid=${portalTemplateId}`, this.httpOptions);
  }

  getProjectPortalGridColumn(portalTemplateId: number) {
    return this.http.get<any>(`${this.configService.config.adminUrl}/api/portaltemplate/getprojectportalgridcolumns?portaltemplateid=${portalTemplateId}`, this.httpOptions);
  }

  getQuickEntryGridColumn() {
    return this.http.get<any>(`${this.configService.config.adminUrl}/api/portaltemplate/getquickentrygridcolumns`, this.httpOptions);
  }

  // PortalTemplate

  getPortalTemplates(): Observable<any> {
    return this.http.get<any>(this.configService.config.adminUrl + '/api/portaltemplate/getportaltemplates', this.httpOptions);
  }

  insertPortalTemplate(rec: any): Observable<any> {
    return this.http.post<any>(this.configService.config.adminUrl + '/api/portaltemplate/addportaltemplate', rec, this.httpOptions);
  }

  updatePortalTemplate(rec: any): Observable<any> {
    return this.http.put<any>(this.configService.config.adminUrl + '/api/portaltemplate/updateportaltemplate', rec, this.httpOptions);
  }

  removePortalTemplate(id: number): Observable<any> {
    return this.http.delete<any>(this.configService.config.adminUrl + '/api/portaltemplate/deleteportaltemplate?portalTemplateId=' + id.toString(), this.httpOptions);
  }

  // PortalTemplateTimeType

  getPortalTemplateTimeTypes(): Observable<any> {
    return this.http.get<any>(this.configService.config.adminUrl + '/api/portaltemplate/getportaltemplatetimetypes', this.httpOptions);
  }

  insertPortalTemplateTimeTypes(rec: any): Observable<any> {
    return this.http.post<any>(this.configService.config.adminUrl + '/api/portaltemplate/addtimetypeids', rec, this.httpOptions);
  }

  removePortalTemplateTimeTypes(rec: any): Observable<any> {
    return this.http.post<any>(this.configService.config.adminUrl + '/api/portaltemplate/deletetimetypeids', rec, this.httpOptions);
  }

  reorderPortalTemplateTimeTypes(portalTemplateId: number, timeTypes: any[]): Observable<any> {
    const request = { PortalTemplateId: portalTemplateId, TimeTypeIds: [] };

    timeTypes.forEach((timeType) => {
      request.TimeTypeIds.push(timeType.TimeTypeId);
    });

    return this.http.patch<any>(this.configService.config.adminUrl + '/api/portaltemplate/reordersequences', request, this.httpOptions);
  }
}
